import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './lagerort.list-view.html',
    styleUrls: ['./lagerort.list-view.scss']
})
export class LagerortListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
